export const TITLE_LOG_STATUSES = [
  'Received', 'Transferred', 'Release', 'Problem', 'BOS'
];

// cachedTitleStatus value for assets with no title log at all.
export const TITLE_STATUS_MISSING = 'Missing';
